import { MANIFESTO, BADGES } from "../data";
import { Reveal, Eyebrow } from "./Reveal";

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-chapters" className="relative py-24 sm:py-32 bg-[#0c0c10]">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow>Why choose SX Heating</Eyebrow>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight">
          Built on <span className="flame-text">trust</span>
        </h2>
      </Reveal>

      <div className="mt-16 space-y-16 sm:space-y-24">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.n}>
            <div className={`grid items-center gap-8 lg:gap-14 lg:grid-cols-2 ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
              <div className="lg:[direction:ltr]">
                <span className="font-display text-6xl sm:text-8xl font-extrabold text-white/5">{m.n}</span>
                <h3 className="-mt-6 sm:-mt-10 font-display text-2xl sm:text-4xl font-bold uppercase tracking-tight">
                  {m.title}
                </h3>
                <p className="mt-4 max-w-md text-lg text-zinc-400 leading-relaxed">{m.text}</p>
              </div>
              <div className="lg:[direction:ltr] overflow-hidden rounded-3xl border border-white/10">
                <img src={m.image} alt={m.title} className="h-64 sm:h-80 w-full object-cover" />
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-20 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {BADGES.map((b, i) => {
          const Icon = b.icon;
          return (
            <Reveal key={b.title} delay={i * 0.06}>
              <div data-testid={`badge-${i}`} className="h-full rounded-2xl border border-white/10 bg-[#121217] p-6">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-[#f5641e]/30 bg-[#f5641e]/10">
                  <Icon className="h-6 w-6 text-[#f5641e]" />
                </div>
                <h4 className="mt-4 font-display text-lg font-bold">{b.title}</h4>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{b.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
